const namespaced = true;

const defaultState = () => {
  return {
    loading: false,
    millages: [],
    selectedMillage: {},
    edit: false,
    add: false,
    confirm: false,
    selectedVehicle: null,
    vehicles: [],
    search: "",
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  SET_SEARCH(state, search) {
    state.search = search;
  },
  resetState(state) {
    Object.assign(state, defaultState());
  },
  DELETE_SELECTED_VEHICLE(state, id) {
    const index = state.vehicles.map((item) => item.id).indexOf(id);
    index !== -1 ? state.vehicles.splice(index, 1) : "";

    if (state.selectedVehicle && state.selectedVehicle.id === id) {
      state.selectedVehicle = state.vehicles[0] || [];
      state.millages = [];
    }
  },
  EDIT_SELECTED_VEHICLE(state, newVal) {
    const index = state.vehicles.map((item) => item.id).indexOf(newVal.id);
    if(index !== -1){
      state.vehicles.splice(index, 1, newVal)
    }
    if(state.selectedVehicle.id === newVal.id){
      state.selectedVehicle = state.vehicles.filter(item => item.id === newVal.id)[0]
    }
  },
  REMOVE_MILLAGE(state, millages) {
    const index = state.millages.map((item) => item.id).indexOf(millages.id);
    if (index !== -1) {
      state.millages.splice(index, 1);
    }
  },
  EDIT_MILLAGE(state, millage) {
    const index = state.millages.map((item) => item.id).indexOf(millage.id);
    if (index !== -1) {
      state.millages.splice(index, 1, millage);
    }
  },
  SET_VEHICLES(state, vehicles) {
    state.vehicles = vehicles;
  },
  SET_SELECTED_VEHICLE(state, selectedVehicle) {
    state.selectedVehicle = selectedVehicle;
  },
  ADD_MILLAGE(state, millage) {
    state.millages = [...state.millages, millage];
  },
  SET_MILLAGES(state, millages) {
    state.millages = millages;
  },
  SET_SELECTED_MILLAGE(state, selectedMillage) {
    state.selectedMillage = selectedMillage;
  },
  SET_EDIT(state, edit) {
    state.edit = edit;
  },
  SET_ADD(state, add) {
    state.add = add;
  },
  SET_CONFIRM(state, confirm) {
    state.confirm = confirm;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
